module.exports = __webpack_public_path__ + "media/96673-success.c7583bde.mp4";